

















import Vue from "vue";
export default Vue.extend({
  data: function() {
    return {
      probability: 0.1,
      overlap: 0.2
    };
  },
  methods: {
      onSubmit() {
        //   store.commit()
      },
      onReset() {
          this.probability = 0.1;
          this.overlap = 0.2;
      }
  }
});
